import Client from "./client"

export default class Project {
    constructor() {
        this.client = new Client
    }

    async users() {
        return await this.client.http().get("/v1/project/users")
    }

    async apiUsers() {
        return await this.client.http().get("/v1/user/api-user")
    }
}